import Base from 'netxcore@netx/core/lib/netx-session';
import {getUserLevel} from '@netx/core-user-next/utils/getUserLevel';

/** @override */
export default class Session extends Base {
	/**
	 * @override
	 * @fires module:auth#auth:user:logout
	 */
	expireSession() {
		if (getUserLevel() <= 0) return;

		this.deleteCookie('sessionKey');
		this.setCookie('sessionExpired', 'EXPIRED', 1);

		dispatcher.trigger('auth:user:logout');
	}
}
